import Immutable from 'immutable';
import { handleActions } from 'redux-actions';
import { TYPES as ANNUAL_AVAILABILITY_TYPES } from 'actions/annualAvailabilityActions';
import { TYPES as SEARCH_RESULTS_TYPES } from 'actions/searchResultsActions';
import { TYPES as DAY_OF_MONTH_TYPES } from 'actions/dayOfMonthActions';
import { TYPES as DIMENSIONS_TYPES } from 'actions/dimensionsActions';
import { TYPES as DIMENSIONS_AVAILABILITY_TYPES } from 'actions/dimensionsAvailabilityActions';
import { TYPES as SEARCH_UNIT_TYPES } from 'actions/searchUnitActions';
import { TYPES as HOTEL_DETAILS_TYPES } from 'actions/hotelDetailsActions';
import { checkForNestedProperty } from 'utils/utils';

const initialState = Immutable.Map();

function reducerCallback(state, action) {
  let response = state;

  if (checkForNestedProperty(action, 'response.entities.dimensions')) {
    response = state.mergeDeep(action.response.entities.dimensions);
  }

  return response;
}

const dayOfMonthSuccess = (state, action) => {
  let response = state;

  if (checkForNestedProperty(action, 'response.entities.dimensions')) {
    response = state.merge(action.response.entities.dimensions);
  }

  return response;
};

export default handleActions({
  [ANNUAL_AVAILABILITY_TYPES.ANNUAL_AVAILABILITY_SUCCESS]: reducerCallback,
  [SEARCH_RESULTS_TYPES.SEARCH_RESULTS_SUCCESS]: reducerCallback,
  [DIMENSIONS_TYPES.DIMENSIONS_RESULTS_SUCCESS]: reducerCallback,
  [HOTEL_DETAILS_TYPES.HOTEL_DETAILS_SUCCESS]: reducerCallback,
  [DAY_OF_MONTH_TYPES.DAY_OF_MONTH_SUCCESS]: dayOfMonthSuccess,
  [SEARCH_UNIT_TYPES.DAY_OF_MONTH_SUCCESS]: dayOfMonthSuccess,
  [ANNUAL_AVAILABILITY_TYPES.CHANGE_NUMBER_OF_NIGHTS]: (state, action) => state
      .setIn([action.addDimId, 'selected'], true)
      .setIn([action.removeDimId, 'selected'], false)
      .setIn([action.removeDimId, 'available'], true),
  [ANNUAL_AVAILABILITY_TYPES.SET_DIMENSION_PROPERTY]: (state, action) => state
      .setIn([action.dimId, action.key], action.value),
  [DIMENSIONS_AVAILABILITY_TYPES.DIMENSIONS_AVAILABILITY_SUCCESS]: (state, action) => {
    let response = state;
    if (checkForNestedProperty(action, 'response.result.availability')) {
      const availability = action.response.result.availability;
      const availableDimIds = [];

      Object.values(availability).forEach((obj) => {
        availableDimIds.push(...Object.keys(obj));
      });

      response = state.withMutations((mutatedState) => {
        mutatedState.forEach((dim, dimId) => {
          mutatedState.setIn([dimId, 'available'], availableDimIds.indexOf(dimId) > -1);
        });
      });
    }

    return response;
  },
}, initialState);



/** WEBPACK FOOTER **
 ** ./src/redux/reducers/dimensionsEntitiesReducer.js
 **/